import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import MyTextField from "../forms/MyTextField";
import MySelectField from "../forms/MySelectField";
import MyMultilineField from "../forms/MyMultilineField";
import AxiosInstance from "../Axios";
import Dayjs from "dayjs";
import MyDatePickerField from "../forms/MyDatePickerField";
import MyMultiSelectField from "../forms/MyMultiSelectField";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { fetchVariableValues } from "../../Extractor";
import colors from "../constants/Colors";
import Swal from "sweetalert2";

const EditScientific = () => {
  const project_id = localStorage.getItem("project_id");

  const MyParam = useParams();
  const MyId = MyParam.id;
  //const [loading, setLoading] = useState(true)

  /**Récupère les données associées a la ligne cliquée pour la modification */
  const GetData = () => {
    AxiosInstance.get(`projects/${project_id}/scientifics/${MyId}/`).then(
      (res) => {
        setValue("typePID", res.data.typePID);
        setValue("publisher", res.data.publisher);
        setValue("pidd", res.data.pidd);
        setValue("pidb", res.data.pidb);
        setValue("type", res.data.type);
        setValue("peerReviewed", res.data.peerReviewed);
        setValue("titleB", res.data.titleB);
        setValue("oa", res.data.oa);
        setValue("cost", res.data.cost);
        setValue("license", res.data.license);
        setValue("status", res.data.status);
        setValue("authors", res.data.authors);
        setValue("title", res.data.title);
        setValue("publicationTitle", res.data.publicationTitle);
        setValue("datePublication", Dayjs(res.data.datePublication));
        setValue("shortDescription", res.data.shortDescription);
        setValue("link", res.data.link);
        setValue("otherLink", res.data.otherLink);
        setValue("openAccess", res.data.openAccess);
        setValue("repositoryLink", res.data.repositoryLink);
        setValue("reportingPeriod", res.data.reportingPeriod);
        setValue("audience", res.data.audiences);
        setValue("estimation", res.data.estimation * res.data.audiences.length);
        setValue(
          "partners",
          res.data.participating_partners.map((partner) => partner.name)
        );
      }
    );
  };

  useEffect(() => {
    GetData();
  }, []);

  const navigate = useNavigate();

  const defaultValues = {
    typePID: "",
    status: "",
    publisher: "",
    pidd: "",
    pidb: "",
    type: "",
    authors: "",
    title: "",
    publicationTitle: "",
    datePublication: null,
    shortDescription: "",
    link: "",
    otherLink: "",
    openAccess: "",
    peerReviewed: "",
    repositoryLink: "",
    titleB: "",
    oa: "",
    cost: "",
    license: "",
    reportingPeriod: "",
    audience: "",
    estimation: "",
    partners: [],
  };

  const schema = yup.object({
    type: yup.string().required("The type of publication is required"),
    typePID: yup.string().required("The type of PID is required"),
    publisher: yup.string().required("The publisher name is required"),
    pidb: yup.string(),
    status: yup.string(),

    pidd: yup.string(),
    peerReviewed: yup.string().required("The peer-reviewed is required"),

    authors: yup.string().required("The name of the authors is required"),
    title: yup.string().required("The jounal title or equivalent is required"),
    publicationTitle: yup
      .string()
      .required("The title of the publication is required"),
    datePublication: yup.date(),
    shortDescription: yup.string(),
    link: yup.string(),
    otherLink: yup.string(),
    openAccess: yup.string().required("This field is required"),
    repositoryLink: yup
      .string()
      .required("The PID link or repository is required"),
    titleB: yup.string(),
    oa: yup.string(),
    cost: yup.string(),
    license: yup.string(),
    reportingPeriod: yup.string(),
    audience: yup
      .array()
      .of(yup.string())
      .min(1, "At least one type of audience is required")
      .required("The type of audience is required"),
    estimation: yup
      .number()
      .typeError("Estimation must be a number")
      .required("the estimation is required"),
    partners: yup.array().of(yup.string()),
  });

  const { handleSubmit, setValue, control } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
  });

  const [audienceOptions, setAudienceOptions] = useState([]);
  const [reportingPeriodOptions, setReportingPeriodOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [partners, setPartners] = useState([]);
  const [fullPartnerData, setFullPartnerData] = useState([]);

  useEffect(() => {
    const getOptions = async () => {
      const { values: audienceValues } = await fetchVariableValues("Audiences");
      setAudienceOptions(audienceValues.map((v) => v.name));

      const { values: reportingPeriodValues } = await fetchVariableValues(
        "Reporting Period"
      );
      setReportingPeriodOptions(reportingPeriodValues.map((v) => v.name));

      const { values: statusValues } = await fetchVariableValues(
        "Type of publication"
      );
      setStatusOptions(statusValues.map((v) => v.name));
      console.log("yo", statusValues);
    };

    getOptions();
  }, []);

  const submission = (data) => {
    const Date = Dayjs(data.datePublication).format("YYYY-MM-DD");

    console.log("datapub", data, Date);

    const selectedPartnerIds = data.partners
      ? data.partners
          .map((partnerName) => {
            const partner = fullPartnerData.find((p) => p.name === partnerName);
            return partner ? partner.id : null;
          })
          .filter((id) => id !== null)
      : [];

    AxiosInstance.put(`projects/${project_id}/scientifics/${MyId}/`, {
      typePID: data.typePID,
      publisher: data.publisher,
      pidd: data.pidd,
      pidb: data.pidb,
      type: data.type,
      link: data.link,
      peerReviewed: data.peerReviewed,
      titleB: data.titleB,
      oa: data.oa,
      cost: data.cost,
      license: data.license,
      status: data.status,
      authors: data.authors,
      title: data.title,
      publicationTitle: data.publicationTitle,
      datePublication: Date,
      shortDescription: data.shortDescription,
      //doi: data.doi,
      otherLink: data.otherLink,
      openAccess: data.openAccess,
      repositoryLink: data.repositoryLink,
      reportingPeriod: data.reportingPeriod,
      audiences: data.audience,
      estimation: Math.round(data.estimation / data.audience.length),
      partner_ids: selectedPartnerIds,
    })
      .then((res) => {
        navigate(`/`);
      })
      .catch((error) => {
        console.error("Edit error:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          Swal.fire({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            confirmButtonColor: colors.secondary,
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "An error occurred while editing the Scientific publication.",
            icon: "error",
            confirmButtonColor: colors.secondary,
          });
        }
      });
  };

  const userId = localStorage.getItem("user_id");
  useEffect(() => {
    const getPartnersInProject = async () => {
      try {
        const response = await AxiosInstance.get(
          `projects/${project_id}/get_partners/`
        );

        if (response.status === 200) {
          const userIdNumber = parseInt(userId, 10);

          /*   const filteredPartners = response.data.filter(
            (partner) => partner.pic !== userIdNumber
          ); */

          const filteredPartners = response.data;

          // Extract just the names and IDs for the dropdown
          const partnerOptions = filteredPartners.map(
            (partner) => partner.name
          );
          setPartners(partnerOptions);

          // Store the full partner objects separately if needed
          setFullPartnerData(filteredPartners);
        }
      } catch (error) {
        console.error("There was an error fetching partners!", error);
      }
    };
    getPartnersInProject();
  }, [userId]);

  return (
    <div>
      <form onSubmit={handleSubmit(submission)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: colors.secondary,
            marginBottom: "10px",
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
          }}
        >
          <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
            Edit the publication
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            boxShadow: 3,
            padding: 4,
            flexDirection: "column",
            marginTop: -1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label={
                <span>
                  Type of PID<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="typePID"
              control={control}
              width={"30%"}
              options={["DOI", "Handle", "ARK", "URI", "pURL", "Other", "None"]}
            />
            <MyMultilineField
              label={
                <span>
                  PID link <span style={{ color: "red" }}> *</span>
                </span>
              }
              name="repositoryLink"
              control={control}
              width={"30%"}
            />
            <MyMultilineField
              label="PID of deposited publication"
              name="pidd"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label={
                <span>
                  Type of publication<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="type"
              control={control}
              width={"30%"}
              options={statusOptions}
            />
            <MyMultilineField
              label="Link to publication"
              name="link"
              control={control}
              width={"30%"}
            />
            <MyMultilineField
              label={
                <span>
                  Title of publication<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="publicationTitle"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label={
                <span>
                  Authors<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="authors"
              control={control}
              width={"30%"}
            />{" "}
            <MyMultilineField
              label={
                <span>
                  Title of the Journal or equivalent{" "}
                  <span style={{ color: "red" }}> *</span>
                </span>
              }
              // label="Title of the Journal or equivalent"
              name="title"
              control={control}
              width={"30%"}
            />
            <MyMultilineField
              label="Number"
              name="shortDescription"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label="ISSN or eISSN"
              name="otherLink"
              control={control}
              width={"30%"}
            />
            <MyMultilineField
              label={
                <span>
                  Publisher<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="publisher"
              control={control}
              width={"30%"}
            />
            <MyDatePickerField
              label={
                <span>
                  Date<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="datePublication"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label={
                <span>
                  Open access<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="openAccess"
              control={control}
              width={"30%"}
              options={["Yes", "No"]}
            />

            <MySelectField
              label={
                <span>
                  Peer-reviewed<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="peerReviewed"
              control={control}
              width={"30%"}
              options={["Yes", "No"]}
            />
            <MyMultilineField
              label="PID of book"
              name="pidb"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label="Book tilte"
              name="titleB"
              control={control}
              width={"30%"}
            />
            <MySelectField
              label="The project cover OA publishing fees"
              name="oa"
              control={control}
              width={"30%"}
              options={["Yes", "No"]}
            />
            <MyMultilineField
              label="Fees charged to the project ?"
              name="cost"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label="License type"
              name="license"
              control={control}
              width={"30%"}
              options={[
                "CC BY NC or equivalent",
                "CC BY NC ND or equivalent",
                "CC BY or equivalent",
                "Other",
              ]}
            />
            <MySelectField
              label="Reporting Period"
              name="reportingPeriod"
              control={control}
              width={"50%"}
              options={reportingPeriodOptions}
            />

            <MyMultiSelectField
              label={
                <span>
                  Type of audience<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="audience"
              control={control}
              width={"30%"}
              options={audienceOptions}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <MySelectField
              label="Status"
              name="status"
              control={control}
              width={"30%"}
              options={[
                "submitted",
                "pending",
                "accepted",
                "published",
                "Other",
              ]}
            />
            <MyTextField
              label={
                <span>
                  Estimation audiences<span style={{ color: "red" }}> *</span>
                </span>
              }
              name="estimation"
              type="number"
              placeholder="Provide estimation"
              control={control}
              width={"30%"}
            />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", marginTop: 2 }}>
            <span style={{ display: "flex", justifyContent: "flex-start" }}>
              Would you like to add partner(s) to this publication?
            </span>
            <hr />
            <br />
            <MyMultiSelectField
              label="Partners"
              name="partners"
              control={control}
              width={"30%"}
              options={partners}
            />
            <br />

            {/* Alignement des boutons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                marginTop: 2,
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  width: "150px",
                  backgroundColor: colors.secondary,
                  marginRight: 2,
                }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/")}
                sx={{ width: "150px", backgroundColor: "gray" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default EditScientific;
